import {Matcher} from '@/lib/axiosAddTransforms'
import {
  propertyResponse,
} from '@/transformers/utils'

const matchers: Matcher[] = [
  {
    test: /^\/users\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/users/`
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return data
        }
        return {
          results: data.results.map((result) => userResponse(result)),
            ...propertyResponse(data),
        }
      }
    },
  },
  {
    test: /^\/users\/\$id\/?$/,
    method: 'delete',
    transform: {
      request: (payload) => {
        const {bizId, userId} = payload.params
        payload.url = `/bizs/${bizId}/users/${userId}`
        delete payload.params.bizId
        delete payload.params.userId
        return payload
      },
      response: (data) => data
    },
  },
  {
    test: /^\/invitations\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.params
        const {phoneNumber} = payload.data
        payload.url = `/bizs/${bizId}/invitations/`
        payload.data = {phoneNumber}
        delete payload.params.bizId
        return payload
      },
      response: (data) => data
    },
  },
]

const userResponse = (data) => {
  const {id, inviteStatus, user} = data
  return {
    ...data,
    id: String(id),
    userId: String(user),
    status: inviteStatus,
  }
}

export default matchers
